import { ChainId } from '@shared/utils/config/networks';
import { clsx } from 'clsx';
import { ethers } from 'ethers';
import { twMerge } from 'tailwind-merge';
import validateSolAddress from '@/lib/misc/validateSolAddress';
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
export function toLocaleFixedNumber(value) {
  const localeString = Number(value).toLocaleString();
  if (localeString == '0') {
    return '0.00';
  }
  return localeString.slice(0, localeString.indexOf('.') + 3);
}
export function numberWithCommas(x) {
  if (!x && x !== 0) return '';
  let value = x.toString();
  // Remove trailing decimal if present
  if (value[value.length - 1] === '.') {
    value = value.substring(0, value.length - 1);
  }
  const parts = value.split('.');
  const integerPart = parts[0];
  const fractionalPart = parts[1];
  const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return fractionalPart ? `${formattedIntegerPart}.${fractionalPart}` : formattedIntegerPart;
}
export function numberFromString(x) {
  let value = x;
  if ((x === null || x === void 0 ? void 0 : x[x.length - 1]) === '.') {
    value = x === null || x === void 0 ? void 0 : x.substring(0, x.length - 1);
  }
  return parseFloat(value);
}
export function toSpecialFixed(value, decimals = 3, allowScientificNotation = false, includeCommas = true) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
  const floatValue = typeof value === 'string' ? parseFloat(value) : value;
  const lastCharacterisDot = ((_a = value === null || value === void 0 ? void 0 : value.toString()) === null || _a === void 0 ? void 0 : _a.charAt(((_b = value === null || value === void 0 ? void 0 : value.toString()) === null || _b === void 0 ? void 0 : _b.length) - 1)) === '.';
  if (lastCharacterisDot) {
    return {
      value: includeCommas ? numberWithCommas(value) : value === null || value === void 0 ? void 0 : value.toString(),
      numDecimals: 0
    };
  }
  let firstNonZeroDecimalIndex = (_e = (_d = (_c = value === null || value === void 0 ? void 0 : value.toString()) === null || _c === void 0 ? void 0 : _c.split('.')) === null || _d === void 0 ? void 0 : _d[1]) === null || _e === void 0 ? void 0 : _e.search(/[^0]/);
  if ((_f = value === null || value === void 0 ? void 0 : value.toString()) === null || _f === void 0 ? void 0 : _f.includes('e')) {
    const decimals = parseFloat((_h = (_g = value === null || value === void 0 ? void 0 : value.toString()) === null || _g === void 0 ? void 0 : _g.split('e')) === null || _h === void 0 ? void 0 : _h[1]);
    if (decimals < 0) {
      firstNonZeroDecimalIndex = Math.abs(decimals);
    }
  }
  if (firstNonZeroDecimalIndex == undefined) {
    return {
      value: includeCommas ? numberWithCommas((_j = Number(value)) === null || _j === void 0 ? void 0 : _j.toFixed(0)) : (_k = Number(value)) === null || _k === void 0 ? void 0 : _k.toFixed(0),
      numDecimals: 0
    };
  }
  if (floatValue > 1) {
    if (firstNonZeroDecimalIndex > 8 && !allowScientificNotation) {
      firstNonZeroDecimalIndex = 1;
    }
  }
  const numberToFix = firstNonZeroDecimalIndex + decimals;
  const useScientificNotation = allowScientificNotation && numberToFix > 6;
  if (useScientificNotation) {
    return {
      value: includeCommas ? numberWithCommas(Number(value).toExponential(2)) : Number(value).toExponential(2),
      numDecimals: 0
    };
  }
  const numDecimals = (_o = (_m = (_l = value === null || value === void 0 ? void 0 : value.toString()) === null || _l === void 0 ? void 0 : _l.split('.')) === null || _m === void 0 ? void 0 : _m[1]) === null || _o === void 0 ? void 0 : _o.length;
  if (numDecimals <= numberToFix) {
    return {
      value: includeCommas ? numberWithCommas(value === null || value === void 0 ? void 0 : value.toString()) : value === null || value === void 0 ? void 0 : value.toString(),
      numDecimals: numDecimals
    };
  }
  const updatedVal = (_p = Number(value)) === null || _p === void 0 ? void 0 : _p.toFixed(numberToFix);
  if (updatedVal.charAt(updatedVal.length - 1) === '0' && ((_r = (_q = updatedVal === null || updatedVal === void 0 ? void 0 : updatedVal.split('.')) === null || _q === void 0 ? void 0 : _q[1]) === null || _r === void 0 ? void 0 : _r.length) == numberToFix) {
    return {
      value: includeCommas ? numberWithCommas((_s = Number(value)) === null || _s === void 0 ? void 0 : _s.toFixed(numberToFix - 1)) : (_t = Number(value)) === null || _t === void 0 ? void 0 : _t.toFixed(numberToFix - 1),
      numDecimals: numberToFix - 1
    };
  }
  return {
    value: includeCommas ? numberWithCommas((_u = Number(value)) === null || _u === void 0 ? void 0 : _u.toFixed(numberToFix)) : (_v = Number(value)) === null || _v === void 0 ? void 0 : _v.toFixed(numberToFix),
    numDecimals: numberToFix
  };
}
export function toLocaleShortString(value, length, noEllipsis) {
  if (!value) return 'N/A';
  return value.length < (length ? length + 2 : 7) ? value : `${value.slice(0, length !== null && length !== void 0 ? length : 4)}${!noEllipsis ? '...' : ''}`;
}
export function toLocaleAddress(value) {
  if (!value) return 'N/A';
  return `${value.slice(0, 6)}...${value.slice(39, 42)}`;
}
export function toRate(value, value24) {
  if (!value24) {
    return value ? 100 : 0;
  }
  if (!value) {
    return -100;
  }
  return (value > value24 ? 1 : -1) * Math.abs(value - value24) * 100 / value24;
}
const SI_SYMBOL = ['', 'K', 'M', 'B', 'T', 'Q', 'kQ'];
export function abbreviateNumber(number) {
  // @hat tier? (determines SI symbol)
  const tier = Math.log10(Math.abs(number)) / 3 | 0;
  // If zero, we don't need a suffix
  if (tier == 0) return number;
  // Get suffix and determine scale
  const suffix = SI_SYMBOL[tier];
  const scale = Math.pow(10, tier * 3);
  // Scale the number
  const scaled = number / scale;
  // Format number and add suffix
  return (scaled === null || scaled === void 0 ? void 0 : scaled.toFixed(1)) + suffix;
}
export function timeStampDifferenceToDays(timeStamp) {
  try {
    const numDays = Math.floor((Date.now() - timeStamp * 1000) / (1000 * 60 * 60 * 24));
    const numHours = Math.floor((Date.now() - timeStamp * 1000) / (1000 * 60 * 60) % 24);
    if (numDays >= 30) {
      const numYears = Math.floor(numDays / 365);
      const numMonths = Math.floor(numDays % 365 / 30);
      const numDaysLeftOver = numDays % 30;
      return `${numYears > 0 ? numYears + ' Y, ' : ''} ${numMonths > 0 ? numMonths + ' MO, ' : ''} ${numDaysLeftOver > 0 ? numDaysLeftOver + ' D' : ''}`;
    } else {
      return `${numDays} D, ${numHours} H`;
    }
  } catch (error) {
    console.error('timeStampDifferenceToDate error', error);
    return '';
  }
}
export default function timeStampDifferenceToDate(timeStamp) {
  try {
    const numDays = Math.floor((Date.now() - timeStamp * 1000) / (1000 * 60 * 60 * 24));
    const numHours = Math.floor((Date.now() - timeStamp * 1000) / (1000 * 60 * 60) % 24);
    if (numDays >= 365) {
      const numYears = Math.floor(numDays / 365);
      const numDaysLeftOver = numDays % 365;
      return ` ${numYears}Y, ${numDaysLeftOver}D, ${numHours}H`;
    } else {
      return `${numDays}D, ${numHours}H`;
    }
  } catch (error) {
    console.error('timeStampDifferenceToDate error', error);
    return '';
  }
}
export function timeStampDifferenceToHours(timeStamp) {
  try {
    const numDays = Math.floor((Date.now() - timeStamp * 1000) / (1000 * 60 * 60 * 24));
    const numHours = Math.floor((Date.now() - timeStamp * 1000) / (1000 * 60 * 60) % 24);
    const numMins = Math.floor((Date.now() - timeStamp * 1000) / (1000 * 60) % 60);
    const numSecs = Math.floor((Date.now() - timeStamp * 1000) / 1000 % 60);
    if (numDays >= 365) {
      const numYears = Math.floor(numDays / 365);
      const numDaysLeftOver = numDays % 365;
      return `${numYears} years, ${numDaysLeftOver} days, ${numHours} hours ago`;
    } else {
      return `${numDays > 0 ? `${numDays} days, ` : ''}${numHours > 0 ? `${numHours} hours,` : ''}  ${numMins > 0 ? `${numMins} mins,` : ''}  ${numSecs > 0 ? `${numSecs} secs` : ''} ago`;
    }
  } catch (error) {
    console.error('timeStampDifferenceToDate error', error);
    return '';
  }
}
export function isValidAmount(amountToSend, depositAddress, network, token) {
  var _a, _b;
  if (!depositAddress || network != ChainId.SOLANA && !ethers.utils.isAddress(depositAddress) || network == ChainId.SOLANA && !validateSolAddress(depositAddress)) {
    return {
      valid: false,
      error: 'Please enter a valid address'
    };
  }
  if (!amountToSend) {
    return {
      valid: false,
      error: 'Please enter a valid amount'
    };
  }
  if (isNaN(amountToSend)) {
    return {
      valid: false,
      error: 'Please enter a valid amount'
    };
  }
  if (parseFloat((_a = parseFloat(amountToSend)) === null || _a === void 0 ? void 0 : _a.toFixed(2)) > parseFloat((_b = parseFloat(token === null || token === void 0 ? void 0 : token.usd_value)) === null || _b === void 0 ? void 0 : _b.toFixed(2))) {
    return {
      valid: false,
      error: 'Insufficient balance'
    };
  }
  return {
    valid: true,
    error: ''
  };
}
export function getNetworkName(networkName) {
  return networkName === 'eth-mainnet' ? 'Ethereum' : networkName ? networkName.charAt(0).toUpperCase() + networkName.slice(1).replace('-mainnet', '') : '';
}
export function shortAddr(str) {
  if (str == null) return;
  if (str.length <= 8) {
    return str; // Return original string if it's short.
  }
  const firstTwo = str.substring(0, 4);
  const lastThree = str.substring(str.length - 6);
  return `${firstTwo}...${lastThree}`;
}